import apiEndpoint from '../../utils/apiEndpoint'
import AbstractApiClient from './AbstractApiClient'

const API_URL = import.meta.env.VITE_API_URL


/**
 * This API client integrates with miscellaneous PARCS-related endpoints. For
 * endpoints that deal specifically with rows in the parcs table, see
 * /models/Parcs.ts.
 */
class ParcsApi extends AbstractApiClient {

  getOccupancy(
    locationID: number,
    startDate: string,
    endDate: string,
    signal?: AbortSignal,
  ): Promise<GetParcsOccupancyResponse> {
    return apiEndpoint({
      url: `${API_URL}/parcs/occupancy/${locationID}?start=${startDate}&end=${endDate}`,
      method: 'get',
    }, signal)
  }

  getOccupancyWindows(
    locationID: number,
    date: string,
    signal?: AbortSignal,
  ): Promise<GetParcsWindowsResponse> {
    return apiEndpoint({
      url: `${API_URL}/parcs/occupancy/${locationID}/windows/${date}`,
      method: 'get',
    }, signal)
  }

}

export default new ParcsApi()

export interface GetParcsOccupancyResponse {
  dates: {[key: string]: {completed: number, opened: number}}
}

export interface GetParcsWindowsResponse {
  windows: GetParcsWindowsResponseWindow[]
}

export interface GetParcsWindowsResponseWindow {
  start: string // datetime
  end: string // datetime
  completed: number
  opened: number
}
